import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { router } from './router';
import { GlobalErrorBoundary } from './components/error-boundaries/GlobalErrorBoundary';
// Imported for its side effect: creating the logger installs the global
// error and unhandledrejection listeners.
import './services/error-logger';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <RouterProvider router={router} />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);
